// extracted by mini-css-extract-plugin
module.exports = {"overlay":"a2c79c7e7d--overlay--cQkKC","date":"a2c79c7e7d--date--siJ7n","close":"a2c79c7e7d--close--mHsaC"};